import React from 'react';
import {Stack, useTheme} from '@mui/material';

import {AppointmentBookingEnum} from 'main/analytics/gaTagsEnum';
import {HighlightedText} from 'presentation/components';
import {SelectCardList, StyledIcon} from './styles';
import {CardListProps} from './types';
import {useQueryParams} from 'presentation/pages';

export function OdontoCard({text, handleClick, dataTagId, ...cardProps}: CardListProps) {
	const {
		SEARCH_PARAMS: {query},
	} = useQueryParams();
	const {colors} = useTheme();

	return (
		<SelectCardList
			{...cardProps}
			elevation={0}
			data-tag-id={dataTagId}
			sx={{cursor: 'pointer'}}>
			<Stack p={2} gap={1} direction="row" alignItems="center" onClick={handleClick}>
				<Stack gap={0.5}>
					<HighlightedText
						text={text}
						highlight={query}
						dataTagId={AppointmentBookingEnum.SELECIONOU_ESPECIALIDADE_TEXT}
					/>
				</Stack>
				<Stack flex={1} justifyContent={'center'} height={'100%'}>
					<StyledIcon name="arrow-right" size={24} color={colors.brand.primary.blue} />
				</Stack>
			</Stack>
		</SelectCardList>
	);
}
